import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6cd1436&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./RtsPacMan.scss?vue&type=style&index=0&id=c6cd1436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cd1436",
  null
  
)

export default component.exports